<h3 class="mat-h3">Please upgrade your browser</h3>

<mat-dialog-content>
    <ng-container>
        <p class="mat-body">
            We built New Hire Worksheets using the latest techniques and technologies.
            <br>This makes New Hire Worksheets faster and easier to use.
        </p>
        <p class="mat-body"><strong>Unfortunately, your browser doesn't support those technologies.</strong></p>
    </ng-container>
    <ng-container>
        <p class="mat-body">Download one of these great browsers and you'll be on your way:</p>
        <mat-grid-list cols="3" rowHeight="1:1">
            <mat-grid-tile *ngFor="let browser of supportBrowsersResp.SupportedBrowsers">
                <mat-card>
                    <mat-card-content>
                        <a target="_blank" [href]="browser.DownloadUrl">
                            <img class='sbr-img' [src]="browser.Logo" alt="" />
                            <p>{{ browser.BrowserName }}<br/>Version {{ browser.FriendlyVersion }}</p>                            
                        </a>
                    </mat-card-content>
                </mat-card>
            </mat-grid-tile>
        </mat-grid-list>
    </ng-container>
    <ng-container>
        <p class='mat-body'>FOR TECHNICAL SUPPORT</p>        
        <p class='mat-body'><mat-icon>mail</mat-icon><a href="mailto:helpdesk@wordandbrown.com">helpdesk@wordandbrown.com</a><br/><mat-icon>phone</mat-icon>877.440.9469</p>                
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <mat-card>
        <mat-card-content class="alternate-theme" align="end">
            <button type="button" class="nh-custom-button" mat-flat-button color="primary" (click)="Close()">
            Close
            </button>
        </mat-card-content>
    </mat-card>
</mat-dialog-actions>